export var ProductTagEnum;
(function (ProductTagEnum) {
    ProductTagEnum["TODO"] = "TODO";
    ProductTagEnum["AT_CONTACT"] = "AT_CONTACT";
    ProductTagEnum["NETDISK_ATTACHMENT"] = "NETDISK_ATTACHMENT";
    ProductTagEnum["EMAIL_LIKE"] = "EMAIL_LIKE";
    ProductTagEnum["EMAIL_TEMPLATE"] = "EMAIL_TEMPLATE";
    ProductTagEnum["EMAIL_RECEIVER_IM_GROUP"] = "EMAIL_RECEIVER_IM_GROUP";
    ProductTagEnum["READ_STATUS_TRACK"] = "READ_STATUS_TRACK";
    ProductTagEnum["MEETING_SETTING"] = "MEETING_SETTING";
    ProductTagEnum["SCHEDULE_SETTING"] = "SCHEDULE_SETTING";
    ProductTagEnum["CALENDAR_SHARING_SUBSCRIBE"] = "CALENDAR_SHARING_SUBSCRIBE";
    ProductTagEnum["CONTACT_RECV_NOTIFY"] = "CONTACT_RECV_NOTIFY";
    ProductTagEnum["LOGIN_DEVICE_NOTIFY"] = "LOGIN_DEVICE_NOTIFY";
    ProductTagEnum["ONLINE_RESOURCE"] = "ONLINE_RESOURCE";
    ProductTagEnum["ADVANCED_SEARCH"] = "ADVANCED_SEARCH";
    ProductTagEnum["AGGREGATION_EMAIL"] = "AGGREGATION_EMAIL";
    ProductTagEnum["EMAIL_LIST"] = "EMAIL_LIST";
})(ProductTagEnum || (ProductTagEnum = {}));
export const AUTH_CONFIG = 'AUTH_CONFIG';
export const AUTH_TYPE_CONFIG = 'AUTH_TYPE_CONFIG';
export var AuthorityFeature;
(function (AuthorityFeature) {
    AuthorityFeature["PRAISE_EMAIL_WRITE_EMAIL_ENTRANCE"] = "PRAISE_EMAIL_WRITE_EMAIL_ENTRANCE";
    AuthorityFeature["PRAISE_EMAIL_MEDAL"] = "PRAISE_EMAIL_MEDAL";
    AuthorityFeature["READ_EMIAIL"] = "READ_EMIAIL";
    AuthorityFeature["VIP_CS_ENTRANCE"] = "VIP_CS_ENTRANCE";
    AuthorityFeature["VIP_CS_SEND_MESSAGE"] = "VIP_CS_SEND_MESSAGE";
    AuthorityFeature["STRANGER_NOTIFY_SETTING_PAGE"] = "STRANGER_NOTIFY_SETTING_PAGE";
    AuthorityFeature["STRANGER_NOTIFY"] = "STRANGER_NOTIFY";
    AuthorityFeature["MAIL_TRACE_SHOW_READ_STATUS"] = "MAIL_TRACE_SHOW_READ_STATUS";
    AuthorityFeature["MAIL_TRACE_WRITE_EMAIL"] = "MAIL_TRACE_WRITE_EMAIL";
    AuthorityFeature["ADMIN_SITE_ENTRANCE"] = "ADMIN_SITE_ENTRANCE";
})(AuthorityFeature || (AuthorityFeature = {}));
export var ProductAuthorityFeature;
(function (ProductAuthorityFeature) {
    ProductAuthorityFeature["PRAISE_EMAIL_WRITE_EMAIL_ENTRANCE_SHOW"] = "PRAISE_EMAIL_WRITE_EMAIL_ENTRANCE_SHOW";
    ProductAuthorityFeature["PRAISE_EMAIL_MEDAL_OP"] = "PRAISE_EMAIL_MEDAL_OP";
    ProductAuthorityFeature["PRAISE_EMAIL_MEDAL_VIEW"] = "PRAISE_EMAIL_MEDAL_VIEW";
    ProductAuthorityFeature["PRAISE_EMAIL_MEDAL_CANCEL"] = "PRAISE_EMAIL_MEDAL_CANCEL";
    ProductAuthorityFeature["PRAISE_EMAIL_MEDAL_DECORATE"] = "PRAISE_EMAIL_MEDAL_DECORATE";
    ProductAuthorityFeature["READ_EMIAIL_TRANSLATIONS"] = "READ_EMIAIL_TRANSLATIONS";
    ProductAuthorityFeature["VIP_CS_ENTRANCE_SHOW"] = "VIP_CS_ENTRANCE_SHOW";
    ProductAuthorityFeature["VIP_CS_ENTRANCE_SEND"] = "VIP_CS_ENTRANCE_SEND";
    ProductAuthorityFeature["STRANGER_NOTIFY_SETTING_PAGE_VIEW"] = "STRANGER_NOTIFY_SETTING_PAGE_VIEW";
    ProductAuthorityFeature["MAIL_TRACE_SHOW_READ_STATUS_INNER_DOMAIN"] = "MAIL_TRACE_SHOW_READ_STATUS_INNER_DOMAIN";
    ProductAuthorityFeature["MAIL_TRACE_SHOW_READ_STATUS_INNER_OUT_DOMAIN"] = "MAIL_TRACE_SHOW_READ_STATUS_INNER_OUT_DOMAIN";
    ProductAuthorityFeature["MAIL_TRACE_WRITE_EMAIL_SHOW"] = "MAIL_TRACE_WRITE_EMAIL_SHOW";
    ProductAuthorityFeature["ADMIN_SITE_ENTRANCE_SHOW"] = "ADMIN_SITE_ENTRANCE_SHOW";
    ProductAuthorityFeature["IM_SHOW"] = "IM_SHOW";
    ProductAuthorityFeature["COLLEAGUE_EMAIL_VIEW"] = "COLLEAGUE_EMAIL_VIEW";
    ProductAuthorityFeature["CONTACT_EMAIL_VIEW"] = "CONTACT_EMAIL_VIEW";
    ProductAuthorityFeature["ORG_SETTING_UPDATE_PASSWORD_SHOW"] = "ORG_SETTING_UPDATE_PASSWORD_SHOW";
    ProductAuthorityFeature["ORG_SETTING_BIG_ATTACH_SHOW"] = "ORG_SETTING_BIG_ATTACH_SHOW";
})(ProductAuthorityFeature || (ProductAuthorityFeature = {}));
